const data = [
  { id: 0, name: "Ativo" },
  { id: 1, name: "Inativo" },
  { id: 3, name: "Bloqueado" },
];

export default [...data];
